// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"cbda1cac","894":"507c77bf"}[chunkId] + ".chunk.js";
};